"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountDetectionApi = accountDetectionApi;
exports.configCheckUnique = configCheckUnique;
exports.configGetUniq = configGetUniq;
exports.configInfo = configInfo;
exports.configSaveForm = configSaveForm;
exports.configSaveUniq = configSaveUniq;
exports.configUpdate = configUpdate;
exports.frontDomainApi = frontDomainApi;
exports.getSystemColorApi = getSystemColorApi;
exports.integralGetConfigApi = integralGetConfigApi;
exports.integralSetConfigApi = integralSetConfigApi;
exports.knowUserCaptchaApi = knowUserCaptchaApi;
exports.knowUserSmsCaptchaApi = knowUserSmsCaptchaApi;
exports.mediadomainApi = mediadomainApi;
exports.passAppInfoApi = passAppInfoApi;
exports.passAppSaveApi = passAppSaveApi;
exports.saveSystemColorApi = saveSystemColorApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function configCheckUnique(pram) {
  var data = {
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/platform/system/config/check',
    method: 'GET',
    params: data
  });
}
function configInfo(pram) {
  var data = {
    formId: pram.id
  };
  return (0, _request.default)({
    url: '/admin/platform/system/config/info',
    method: 'GET',
    params: data
  });
}
function configSaveForm(pram) {
  return (0, _request.default)({
    url: '/admin/platform/system/config/save/form',
    method: 'POST',
    data: pram
  });
}
function configUpdate(pram) {
  var data = {
    id: pram.id,
    systemConfigRequest: pram.systemConfigRequest
  };
  return (0, _request.default)({
    url: '/admin/platform/system/config/update',
    method: 'POST',
    params: data
  });
}
function configSaveUniq(pram) {
  var data = {
    key: pram.key,
    value: pram.value
  };
  return (0, _request.default)({
    url: '/admin/platform/system/config/saveuniq',
    method: 'POST',
    params: data
  });
}
function configGetUniq(pram) {
  var data = {
    key: pram.key
  };
  return (0, _request.default)({
    url: '/admin/platform/system/config/getuniq',
    method: 'GET',
    params: data
  });
}

/**
 * 获取积分配置
 */
function integralGetConfigApi() {
  return (0, _request.default)({
    url: '/admin/platform/integral/get/config',
    method: 'GET'
  });
}

/**
 * 编辑积分配置
 */
function integralSetConfigApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/integral/set/config',
    method: 'post',
    data: data
  });
}

/**
 * 获取移动端域名
 */
function frontDomainApi() {
  return (0, _request.default)({
    url: '/publicly/config/get/front/domain',
    method: 'get'
  });
}

/**
 * 获取平台当前的素材地址
 */
function mediadomainApi() {
  return (0, _request.default)({
    url: '/publicly/config/get/admin/mediadomain',
    method: 'get'
  });
}

/**
 * 获取主题色
 */
function getSystemColorApi() {
  return (0, _request.default)({
    url: '/admin/platform/system/config/get/change/color',
    method: 'get'
  });
}

/**
 * 保存主题色
 */
function saveSystemColorApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/system/config/save/change/color',
    method: 'post',
    data: data
  });
}

/**
 * @description 一号通 应用保存
 */
function passAppSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/one/pass/app/info/save',
    method: 'post',
    data: data
  });
}

/**
 * @description 一号通 应用详情获取
 */
function passAppInfoApi() {
  return (0, _request.default)({
    url: '/admin/platform/one/pass/app/info/get',
    method: 'get'
  });
}

/**
 * @description 账号登录检测
 */
function accountDetectionApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/login/account/detection',
    method: 'post',
    data: data
  });
}

/**
 * @description 验证行为验证码
 */
function knowUserSmsCaptchaApi(data) {
  return (0, _request.default)({
    url: '/publicly/safety/check',
    method: 'post',
    data: data
  });
}

/**
 * @description 获取行为验证码
 */
function knowUserCaptchaApi(data) {
  return (0, _request.default)({
    url: '/publicly/safety/get',
    method: 'post',
    data: data
  });
}